require("appdev/wizards/org_search.scss");

class OrgSearch extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { 
			searchParms: { page: props.page || 1, perPage: props.perPage || 20 },
			searchMode: 'standard', // 'standard' or 'fuzzy'
			fuzzySearchText: ''
		}
	}

	// submit on enter (only for standard search inputs)
	handleKeyDown(e) {
		if (e.keyCode === 13 && this.state.searchMode === 'standard') {
			this.submitSearch();
		}
	}

	updateSearchParams(attribute, event) {
		if (event.target.value != "") {
			var updatedData = {...this.state.searchParms, [attribute]: event.target.value}
		} else {
			var updatedData = _.omit(this.state.searchParms, attribute);
		}
		this.setState({ searchParms: updatedData });
	}

	toggleSearchMode() {
		var newMode = this.state.searchMode === 'standard' ? 'fuzzy' : 'standard';
		this.setState({ searchMode: newMode });
	}

	updateFuzzySearchText(event) {
		this.setState({ fuzzySearchText: event.target.value });
	}

	submitSearch() {
		if (this.state.searchMode === 'fuzzy') {
			// Parse the fuzzy search text (comma-separated or line-separated)
			var rawText = this.state.fuzzySearchText.trim();
			if (!rawText) {
				alert('Please enter school names to search');
				return;
			}
			
			// Split by newlines first, then by commas, and clean up
			var schoolNames = rawText
				.split(/[\n,]/)
				.map(name => name.trim())
				.filter(name => name.length > 0);
			
			if (schoolNames.length === 0) {
				alert('Please enter valid school names');
				return;
			}
			
			// Send fuzzy search parameters
			this.props.onSubmit({ 
				fuzzySchoolNames: schoolNames,
				searchMode: 'fuzzy'
			});
		} else {
			this.props.onSubmit(this.state.searchParms);
		}
	}

	renderSearchForm() {
		var { searchMode } = this.state;
		
		return (
			<div className="orgSearch" onKeyDown={this.handleKeyDown}>
				<div className='orgInputRowOne'>
					<select className="form-control" value={searchMode} onChange={this.toggleSearchMode}>
						<option value="standard">Standard Search</option>
						<option value="fuzzy">Search Multiple Schools</option>
					</select>
					<button className="btn buttonPrimary" onClick={this.submitSearch}>
						Search
					</button>
				</div>
				
				{searchMode === 'standard' ? this.renderStandardSearch() : this.renderFuzzySearch()}
			</div>
		)
	}

	renderStandardSearch() {
		return (
			<div className='orgInputRowTwo'>
				<input type="text" placeholder="Org ID" className="form-control"
					onChange={this.updateSearchParams.bind(this, "orgID")} />
				<input type="text" placeholder="Name" className="form-control"
					onChange={this.updateSearchParams.bind(this, "name")} />
				<input type="text" placeholder="Name (Exact Match)" className="form-control"
					onChange={this.updateSearchParams.bind(this, "nameExact")} />
				<input type="text" placeholder="Admin ID" className="form-control"
					onChange={this.updateSearchParams.bind(this, "orgAdminID")} />
			</div>
		)
	}

	renderFuzzySearch() {
		return (
			<div className='orgFuzzySearch'>
				<textarea 
					className="form-control" 
					placeholder="Enter school names (comma-separated or one per line)&#10;Example:&#10;Lincoln High School&#10;Washington Elementary, Jefferson Middle School"
					rows="5"
					value={this.state.fuzzySearchText}
					onChange={this.updateFuzzySearchText}
				/>
				<div className='fuzzySearchHelp'>
					Enter school names separated by commas or on separate lines. The search will find partial matches.
				</div>
			</div>
		)
	}

	render() {
		return (
			<div className="orgSearch">
				{ this.renderSearchForm() }
			</div>
		);
	}

};

OrgSearch.propTypes = PageStrictPropTypes({
	orgType: PropTypes.string.isRequired,
	onSubmit: PropTypes.func.isRequired
});

module.exports = OrgSearch;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/OrgSearch.js